import { gql, useMutation, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import styled from 'styled-components';
import { LoadingWLogo } from '../components/LoadingWLogo';
import logo from "../assets/Farazandishan-logo-1.png";
import { TextBtn } from '../components/inputs/TextBtn';
import { useHistory, Prompt } from 'react-router-dom/cjs/react-router-dom';
import useInterval from '../components/helper/useInterval';
import { Checkbox, Radio } from '@material-ui/core';
import { IconError } from '../assets/IconError';
import { IconTickCircle } from '../assets/IconTickCircle';
import { IconCloseCircle } from '../assets/IconCloseCircle';
const StyleCss = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 80svh;
    position: relative;
    user-select: none;
    .top-bar {
        z-index: 900;
        position: fixed;
        inset: 0 0 auto 0;
        padding: 0 1rem;
        background-color: var(--n-grey-0);
        box-shadow: var(--shadow-2);
        display: flex;
        gap: 1rem;
        align-items: center;
        flex-wrap: wrap;
        img {
            padding: 4px 0;
            height: 52px;
            display: block;
        }
        .test-title {
            font-weight: 600;
        }
        .expand {
            flex-grow: 1;
        }
        .timer {
            min-width: 50px;
            font-weight: 600;
            color: var(--secondry-1);
        }
        .actions {
            min-width: 300px;
            display: flex;
            gap: 0.5rem;
        }
    }
    .side-bar {
        z-index: 890;
        position: fixed;
        inset: 0 auto 0 0;
        padding: 60px 0 0 0;
        background-color: var(--n-grey-0);
        box-shadow: var(--shadow-2);
        display: flex;
        flex-direction: column;
        min-width: 200px;
        overflow-y: auto;
        .title {
            font-weight: 600;
            padding: 1rem 0.5rem;
            border-bottom: 1px solid var(--n-grey-4);
        }
        .section {
            padding: 2rem 0.5rem 1rem;
            border-bottom: 1px solid var(--n-grey-2);
            display: flex;
            justify-content: space-between;
        }
        .question {
            padding: 1rem 0.5rem;
            border-bottom: 1px solid var(--n-grey-2);
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            :last-child{
                border-bottom: none;
            }
            :hover {
                background-color: var(--n-grey-2);
            }
            &.active {
                background-color: var(--n-grey-2);
            }
            .points {
                align-self: center;
                padding: 0.15rem 0.5rem;
                background-color: var(--n-grey-4);
                border-radius: 100px;
            }
        }
    }
    .content {
        margin: 60px 0 0 200px;
        padding: 1rem;
        .selected-question {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            min-height: 300px;
            .question-text {
                display: flex;
                margin: 0.5rem 0;
                font-weight: 500;
                gap: 0.5rem;
                align-items: center;
                max-width: 450px;
                .text {
                    flex-grow: 1;
                }
            }
            .expand {
                flex-grow: 1;
            }
            .line-h {
                height: 1px;
                background-color: var(--n-grey-4);
            }
            .ans {
                display: flex;
                gap: 0.25rem;
                align-items: center;
                label {
                    cursor: pointer;
                    flex-grow: 1;
                }
            }
            .actions {
                margin: 1rem 0;
                display: flex;
                gap: 0.5rem;
                max-width: 450px;
            }
        }
    }
    .exam-ans {
        flex-grow: 1;
        display: flex;
        gap: 1rem;
        flex-direction: column;
        padding: 1rem;
        justify-content: center;
        align-items: center;
        &.error {
            .icon {
                svg {
                    stroke: var(--secondry-1);
                }
            }
        }
        .icon {
            svg {
                width: 120px;
                height: 120px;
                display: block;
                stroke: var(--o-prime-1);
            }
        }
        .text {
            font-size: 1.5rem;
            font-weight: 600;
        }
        .score {
            font-weight: 600;
        }
        .actions {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
        }
    }
    @media screen and (max-width: 800px) {
        .top-bar {
            padding: 0.5rem 1rem;
            img {
                display: none;
            }
        }
        .side-bar{
            inset: 0 auto 0 -200px;
        }
        .content {
            margin: 120px 0 0 0px;
            .selected-question {
                .question-text {
                    align-items: normal;
                    flex-direction: column;
                }
            }
        }
    }
`
export const Exams_Query = gql`
  query OneExamsQuery(
    $_id: ID!
  ){
    getExamForUser(
      _id: $_id
    ) {
        _id
        Title
        Description
        StartDate
        TotalScore
        PassScore
        Time
    }
    getExamSectionsForUser(
      _id: $_id
    ) {
        _id
        ExamBase
        SectionName
        Section
        NumberOfQuestions
    }

    getExamQuestionsForUser(
      _id: $_id
    ) {
        _id
        ExamBase
        Text
        Type
        Section
        Score
        Answers {
            _id
            Text
        }
    }
  }
`
const SendAns_mutation = gql`
    mutation SendAns($_id: ID!, $Ans: [examAnsInput]){
        saveExamForUser(_id: $_id, Ans: $Ans){
            _id
            ExamBase
            Timestamp
            Score
            Passed
            Atemps
        }
    }
`;
export default function VerifiedExam(props) {
    const history = useHistory()
    const [stage, setStage] = useState(0)

    const [selected, setSelected] = useState(0)
    const [ansData, setAnsData] = useState({});
    const exam = useQuery(Exams_Query, {
        variables: {
            _id: props.match.params.id
        },
        onCompleted: (data) => {
            if(data.getExamForUser && data.getExamForUser.Time){
                // set timer
                let sec = data.getExamForUser.Time * 60
                // let sec = 10
                setTime(sec);
                setPaused(false);
            }
        },
        fetchPolicy: "network-only"
    });
    const [SendAnsMutaion, SendAnsMutaionState] = useMutation(SendAns_mutation,{
        onCompleted: (data) => {
            if(data.saveExamForUser){
                setStage(1)
            }
        }
    });

    const [time, setTime] = useState(0);
    const [isPaused, setPaused] = useState(false);
    const intervalRef = useInterval(
        () => {
          if (time > 0) {
            setTime(time - 1);
          } else {
            setPaused(true);
            window.clearInterval(intervalRef.current);
            endExamAndSave()
          }
        },
        isPaused ? null : 1000
    );
    const endExamAndSave = () => {
        let anses = [];
        let baseData = exam.data.getExamQuestionsForUser;
        for (let i = 0; i < baseData.length; i++) {
            const question = baseData[i];
            if(question.Type === "1" || question.Type === "2"){
                if(ansData[question._id]){
                    anses.push({
                        Q_ID: question._id,
                        ANS_ID: question.Answers[ansData[question._id] - 1]._id
                    })
                }
            }
            if(question.Type === "3"){
                if(ansData[question._id]){
                    let checkedData = {...ansData[question._id]};
                    for (let j = 0; j < question.Answers.length; j++) {
                        const ans = question.Answers[j];
                        if(checkedData[j+1]){
                            anses.push({
                                Q_ID: question._id,
                                ANS_ID: ans._id
                            })
                        }
                    }
                    
                }
            }
        }
        SendAnsMutaion({
            variables: {
                _id: props.match.params.id,
                Ans: anses
            }
        })
    }
    if(exam.loading){
        return (
            <StyleCss>
                <LoadingWLogo/>
            </StyleCss>
        )
    }
    let dataBase = {};
    let dataS = [];
    let dataQ = [];
    if(exam.data.getExamForUser){
        dataBase = exam.data.getExamForUser
    }
    if(exam.data.getExamSectionsForUser){
        dataS = exam.data.getExamSectionsForUser
    }
    if(exam.data.getExamQuestionsForUser){
        dataQ = exam.data.getExamQuestionsForUser
    }
    const makeQuestionsForSide = (sections = [], data = []) => {
        let htmlVal = [];
        for (let j = 0; j < sections.length; j++) {
            const sec = sections[j];
            htmlVal.push(
                <div 
                    className={'section '} 
                    key={"sec-" + j}
                >
                    <div className='text'>
                        {sec.SectionName}
                    </div>
                </div>
            )
            data.forEach((v, i) => {
                if(v.Section === sec.Section){
                    htmlVal.push(
                        <div 
                            className={'question ' + (selected === i ? "active" : "")} 
                            onClick={() => {
                                setSelected(i)
                            }}
                            key={i}
                        >
                            <div className='text'>
                                Question No.{i+1}
                            </div>
                            <div className='points'>
                                {v.Score} pt
                            </div>
                        </div>
                    )
                }
            })
        }
        return htmlVal;
        // return data.map((v, i) => {
        //     return (
        //         <div 
        //             className={'question ' + (selected === i ? "active" : "")} 
        //             onClick={() => {
        //                 setSelected(i)
        //             }}
        //             key={i}
        //         >
        //             <div className='text'>
        //                 Question No.{i+1}
        //             </div>
        //             <div className='points'>
        //                 {v.Score} pt
        //             </div>
        //         </div>
        //     )
        // })
    }
    const changeAns1 = (selectedQ, index) => {
        setAnsData((prev) => {
            let temp = {...prev};
            temp[selectedQ._id] = parseInt(index);
            return temp
        })
    }
    const changeAns2 = (selectedQ, index) => {
        setAnsData((prev) => {
            let temp = {...prev};
            let temp1 = {...temp[selectedQ._id]};
            temp1[index] = !temp1[index]
            temp[selectedQ._id] = temp1
            return temp
        })
    }
    const makeAns = (selectedQ = {}) => {
        if(selectedQ.Type === "1" || selectedQ.Type === "2"){
            return selectedQ.Answers.map((v, i) => {
                let index = i + 1
                return (
                    <div 
                        className='ans' 
                        key={i}
                        onClick={() => changeAns1(selectedQ, index)}
                    >
                        <Radio
                            color='primary'
                            id={index+'-i'} 
                            name={selectedQ._id} 
                            value={index}
                            checked={(ansData[selectedQ._id]) ? ansData[selectedQ._id] === index : false}
                        /> 
                        <label htmlFor={index+'-i'}>
                            {v.Text}
                        </label>
                    </div>
                )
            })
        }
        if(selectedQ.Type === "3"){
            return selectedQ.Answers.map((v, i) => {
                let index = i + 1
                let checkedData = {};
                if(ansData[selectedQ._id]){
                    checkedData = {...ansData[selectedQ._id]}
                }
                return (
                    <div 
                        className='ans' 
                        key={i}
                        onClick={() => changeAns2(selectedQ, index)}
                    >
                        <Checkbox
                            color='primary'
                            id={index+'-i'} 
                            name={selectedQ._id} 
                            value={index}
                            checked={(checkedData[index]) ? checkedData[index] : false}
                        /> 
                        <label>
                            {v.Text}
                        </label>
                    </div>
                )
            })
        }
    }
    const makeQuestion = (data = []) => {
        let selectedQ = {};
        if(data.length && selected !== undefined){
            selectedQ = data[selected];
        }
        return (
            <div className='selected-question'>
                <div className='question-text'>
                    <div className='text'>
                        {selected + 1}. {selectedQ.Text}
                    </div>
                    <TextBtn
                        text={"remove selected"}
                        style={{width: "fit-content"}}
                        onclick={() => {
                            setAnsData((prev) => {
                                let temp = {...prev};
                                temp[selectedQ._id] = null;
                                return temp
                            })
                        }}
                        type={""}
                        newType1={2}
                    />
                </div>
                <div className='line-h'></div>
                {makeAns(selectedQ)}
                <div className='expand'></div>
                <div className='line-h'></div>
                <div className='actions'>
                    <TextBtn
                        text={"Previous question"}
                        onclick={() => {
                            if(selected > 0){
                                setSelected(prev => prev - 1)
                            }
                        }}
                        disabled={selected === 0}
                        type={""}
                        newType1={true}
                    />
                    <TextBtn
                        text={"Next question"}
                        onclick={() => {
                            if(selected < data.length - 1){
                                setSelected(prev => prev + 1)
                            }
                        }}
                        disabled={selected === data.length - 1}
                        type={""}
                    />
                    {
                        selected === data.length - 1 ? (
                            <TextBtn
                                onclick={() => {
                                    endExamAndSave()
                                }}
                                loading={SendAnsMutaionState.loading}
                                disabled={SendAnsMutaionState.loading}
                                text={"End exam"}
                                type={""}
                            />
                        ) : ""
                    }
                </div>
            </div>
        )
    }
    const makeTimer = () => {
        let sec = parseInt(time % 60)
        let min = parseInt(time / 60);
        if(sec < 10){
            sec = "0" + sec
        }
        if(min < 10){
            min = "0" + min
        }
        return min + ":" + sec
    }
    if(stage === 1){
        let dataExamAns = {};
        if(SendAnsMutaionState.data.saveExamForUser){
            dataExamAns = SendAnsMutaionState.data.saveExamForUser
        }
        if(dataExamAns.Passed){
            // success
            return (
                <StyleCss>
                    <div className='exam-ans success'>
                        <div className='icon'>
                            <IconTickCircle/>
                        </div>
                        <div className='text'>
                            you have passed the exam
                        </div>
                        <div className='score'>
                            your score: {dataExamAns.Score}
                        </div>
                        <div className='score'>
                            Minimum score to pass: {dataBase.PassScore}
                        </div>
                        <div className='score'>
                            Total score: {dataBase.TotalScore}
                        </div>
                        <div className='actions'>
                            <TextBtn
                                onclick={() => {
                                    history.goBack()
                                }}
                                text={"Go back"}
                                type={""}
                                newType1={true}
                            />
                        </div>
                    </div>
                </StyleCss>
            )
            
        } else {
            // error
            return (
                <StyleCss>
                    <div className='exam-ans error'>
                        <div className='icon'>
                            <IconCloseCircle/>
                        </div>
                        <div className='text'>
                            you have failed the exam
                        </div>
                        
                        <div className='score'>
                            Attempts Remaining: {dataExamAns.Atemps}
                        </div>
                        <div className='score'>
                            your score: {dataExamAns.Score}
                        </div>
                        <div className='score'>
                            Minimum score to pass: {dataBase.PassScore}
                        </div>
                        <div className='score'>
                            Total score: {dataBase.TotalScore}
                        </div>
                        <div className='actions'>
                            <TextBtn
                                onclick={() => {
                                    history.goBack()
                                }}
                                text={"Go back"}
                                type={""}
                                newType1={true}
                            />
                            {
                                dataExamAns.Atemps ? (
                                    <TextBtn
                                        onclick={() => {
                                            window.location.reload()
                                        }}
                                        text={"Take the test again"}
                                        type={""}
                                    />
                                ) : ""
                            }
                        </div>
                    </div>
                </StyleCss>
            )
        }
    }
    
    
    return (
        <StyleCss>
            {/* <Prompt when={true} message={`You have'nt saved the exam. are you sure you want to cancel?`}/> */}
            <div className='top-bar'>
                <img src={logo} alt='farazandishan'/>
                <div className='test-title'>
                    {dataBase.Title}
                </div>
                <div className='expand'></div>
                <div className='timer'>
                    {makeTimer()}
                </div>
                <div className='actions'>
                    <TextBtn
                        onclick={() => {
                            let confirm = window.confirm(`You have'nt saved the exam. are you sure you want to cancel?`);
                            if(confirm){
                                history.goBack()
                            }
                        }}
                        text={"Cancel exam"}
                        type={""}
                        newType1={true}
                    />
                    <TextBtn
                        onclick={() => {
                            endExamAndSave()
                        }}
                        loading={SendAnsMutaionState.loading}
                        disabled={SendAnsMutaionState.loading}
                        text={"End exam"}
                        type={""}
                    />
                </div>
            </div>
            <div className='side-bar'>
                {makeQuestionsForSide(dataS, dataQ)}
            </div>
            <div className='content'>
                {makeQuestion(dataQ)}
            </div>
        </StyleCss>
    )
};
